import { render, staticRenderFns } from "./BuMen.vue?vue&type=template&id=bc7d3d32&scoped=true"
import script from "./BuMen.vue?vue&type=script&lang=js"
export * from "./BuMen.vue?vue&type=script&lang=js"
import style0 from "./BuMen.vue?vue&type=style&index=0&id=bc7d3d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7d3d32",
  null
  
)

export default component.exports